// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"95bccb07","337":"37b84a47","455":"7022e7d8"}[chunkId] + ".chunk.js";
};